import React, {useEffect, useRef} from "react";
import {List, ListItem} from "@mui/material";
import {useAutoVisitList} from "~/apps/packages/auto-visits/hooks";
import {AutoVisitItem} from "~/apps/packages/auto-visits/components/AutoVisitList/AutoVisitItem";
import {AutoVisit} from "~/apps/packages/auto-visits/queries";
import {useHistory} from "react-router-dom";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {Box} from "@mui/system";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export type AutoVisitListProps = {
    onLoading?: (loading: boolean) => any
    onChange?: (pageInfo: { count: number }) => any
    statuses?: AutoVisit["status"][]
    dateFrom?: Date
    dateTo?: Date
    query?: string
    carrierId: string
}


export const AutoVisitList = (props: AutoVisitListProps) => {
    const {onLoading, onChange, statuses, query, dateFrom, dateTo, carrierId} = props;
    const history = useHistory();
    const {data, loading, fetchMore, canFetchMore} = useAutoVisitList({
        carrierId: carrierId,
        query: query,
        status: statuses,
        dateFrom: dateFrom,
        dateTo: dateTo,
    });

    const setScrollNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    useEffect(() => {
        if (data) {
            onChange && onChange({count: data.length || 0});
        }
    }, [data]);

    useEffect(() => {
        onLoading && onLoading(loading);
    }, [loading]);

    const handleItemClick = (item: { number: string }) => {
        history.push(`/${encodeURI(item.number)}`);
    }

    const handleRef = (node) => {
        setScrollNode(findScrollableNode(node));
    }

    return (
        <LoadingBox isInitialLoading={data === undefined} loading={loading} empty={data?.length == 0} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {data?.map((item) => (
                        <ListItem onClick={() => handleItemClick(item)} key={`${item.id}:${item.number}`}>
                            <AutoVisitItem autoVisit={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    )
}